import * as Yup from "yup";

/**
 * Construye los valores iniciales para el formulario,
 * con la posibilidad de setear 'classNumber' por defecto.
 */
export function buildInitialValues(classNumber) {
  return {
    nameRute: "",
    description: "",
    // Si llega un 'classNumber' por props, lo asignamos. Si no, vacío.
    classnumber: classNumber || "",
  };
}

/**
 * Esquema de validaciones con Yup
 * @param {Function} t - i18n translation function from useTranslation('itineraries')
 */
export function validationSchema(t) {
  return Yup.object({
    nameRute: Yup.string().required(t("validation.nameRequired")),
    description: Yup.string(), // Podrías poner un .required() si deseas
    classnumber: Yup.string().required(t("validation.classRequired")),
  });
}
